// extracted by mini-css-extract-plugin
export default {"title":"CompanyTop5_title__Z-YOz","chartContainer":"CompanyTop5_chartContainer__nohOO","tooltip":"CompanyTop5_tooltip__ld2kE"};